export default "__VITE_ASSET__j1MIQzxf__"